<template>
  <footer class="section footer-modern">
    <div class="footer-modern-body section-xl">
      <div class="container">
        <div class="row row-40 row-md-50 justify-content-xl-between">
          <div class="col-md-10 col-lg-3 col-xl-4 wow fadeInRight">
            <div class="inset-xl-right-70">
              <h5 class="footer-modern-title">企业证书</h5>
              <div class="row row-10 gutters-10" data-lightgallery="group">
                <div v-for="(item,index) in zsList" :key="index" class="col-4 col-xs-4  col-sm-2 col-lg-4">
                  <!-- Thumbnail Minimal--><a
                  class="thumbnail-minimal"
                  :href="item.img"
                  data-lightgallery="item"
                  target="_blank"
                ><img
                  :src="item.img"
                  alt=""
                  width="178"
                  height="178"
                /></a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-7 col-lg-5 wow fadeInRight"
            data-wow-delay=".1s"
          >
            <h5 class="footer-modern-title">友情链接</h5>
            <ul
              class="footer-modern-list footer-modern-list-2 d-sm-inline-block d-md-block"
            >
              <li><router-link to="/companyintroduction">企业简介</router-link></li>
              <li><router-link to="/software">产品展厅</router-link></li>
              <li><router-link to="/contactus">联系我们</router-link></li>
<!--              <li><a href="javascript:;">产品展厅</a></li>-->
<!--              <li><a href="javascript:;">联系我们</a></li>-->
              <!-- <li><a href="shop-list.html">产品展厅</a></li> -->
              <!-- <li><a href="testimonials.html">客户评价</a></li> -->
              <!-- <li><a href="#">常见问题</a></li> -->
<!--              <li><a href="contact-us.html">联系我们</a></li>-->
              <!-- <li><a href="#">配件</a></li> -->
              <!-- <li><a href="#">护理</a></li> -->
              <!-- <li><a href="#">服装</a></li> -->
              <li><a href="http://www.bgzsh.cn/" target="_blank" >临泉博古斋书画</a></li>
              <li><a href="http://www.bgzsh.cn/" target="_blank" >临泉博古斋书画</a></li>
              <li><a href="http://www.bgzsh.cn/" target="_blank" >临泉博古斋书画</a></li>
<!--              <li><a href="javascript:;">食品</a></li>-->
<!--              <li><a href="javascript:;">美容用品</a></li>-->
            </ul>
          </div>
          <div
            class="col-sm-6 col-md-5 col-lg-4 col-xl-3 wow fadeInRight"
            data-wow-delay=".2s"
          >
            <h5 class="footer-modern-title">关于我们</h5>
            <ul class="contacts-creative">
              <li>
                <div class="unit unit-spacing-sm flex-column flex-md-row">
                  <div class="unit-left">
                    <span class="icon mdi mdi-map-marker linear-icon"></span>
                  </div>
                  <div class="unit-body">
                    <a href="javascript:;"
                    >地址：安徽省阜阳市临泉县X062</a
                    >
                  </div>
                </div>
              </li>
              <li>
                <div class="unit unit-spacing-sm flex-column flex-md-row">
                  <div class="unit-left">
                    <span class="icon mdi mdi-phone linear-icon"></span>
                  </div>
                  <div class="unit-body">
                    <a href="tel:13075063180">电话：13075063180</a><br>
                  </div>
                </div>
              </li>
              <li>
                <div class="unit unit-spacing-sm flex-column flex-md-row">
                  <div class="unit-left">
                    <span class="icon mdi mdi-email-outline linear-icon"></span>
                  </div>
                  <div class="unit-body">
                    <a href="javascript:;">微信号：wangeerjiaju</a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-modern-panel text-center">
      <div class="container">
        <p class="rights">
          <span>Copyright  &copy;&nbsp;</span><span class="copyright-year"></span
        ><span> 2025 &nbsp;&nbsp;</span
        ><a target="_blank"
        >临泉超强床垫有限公司</a
        >
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      zsList: [
        {
          img: require("@/assets/img/zs001.jpg")
        },
        {
          img: require("@/assets/img/zs002.jpg")
        },
        {
          img: require("@/assets/img/zs003.jpg")
        },
        {
          img: require("@/assets/img/zs004.jpg")
        },
        {
          img: require("@/assets/img/zs005.jpg")
        },
        {
          img: require("@/assets/img/zs006.jpg")
        },
      ],
    };
  },
  methods: {
  }
};
</script>
<style scoped>


a:focus {
  outline: none !important;
}

*:focus {
  outline: none;
}

p {
  margin: 0;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li {
  display: block;
}

html p a:hover {
  text-decoration: none;
}

/*
* Typography
*/
body {
  text-align: center;
  font-size: 13px;
  line-height: 1.6;
  font-weight: 400;
  letter-spacing: .03em;
  font-family: "Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #777777;
  background-color: #ffffff;
  -webkit-text-size-adjust: none;
  -webkit-font-smoothing: subpixel-antialiased;
}

@media (min-width: 768px) {
  body {
    font-size: 15px;
  }
}

h5 {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 600;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  letter-spacing: normal;
  color: #151515;
}

h5 {
  font-size: 16px;
  line-height: 1.66667;
}

@media (min-width: 768px) {
  h5 {
    font-size: 18px;
  }
}

h5 {
  text-transform: none;
}

::selection {
  background: #959af1;
  color: #ffffff;
}

::-moz-selection {
  background: #959af1;
  color: #ffffff;
}

/*
* Brand
*/

/*
* Links
*/
a {
  transition: all 0.25s ease-in-out;
}

a, a:focus, a:active, a:hover {
  text-decoration: none;
}

a, a:focus, a:active {
  color: #959af1;
}

a:hover {
  color: #515ae8;
}

a[href*='tel'], a[href*='mailto'] {
  white-space: nowrap;
}

/*
* Blocks
*/

/*
*
* Boxes
*/

/*
* Element groups
*/

/*
* Responsive units
*/
.unit {
  display: flex;
  flex: 0 1 100%;
  margin-bottom: -10px;
  margin-left: -10px;
}

.unit > * {
  margin-bottom: 10px;
  margin-left: 10px;
}

.unit-body {
  flex: 0 1 auto;
}

.unit-left {
  flex: 0 0 auto;
  max-width: 100%;
}

.unit-spacing-sm {
  margin-bottom: -10px;
  margin-left: -20px;
}

.unit-spacing-sm > * {
  margin-bottom: 10px;
  margin-left: 20px;
}


/*
* Images
*/
img {
  display: inline-block;
  max-width: 100%;
  height: auto;
}

/*
* Icons
*/
.icon {
  display: inline-block;
  font-size: 16px;
  line-height: 1;
}

.icon::before {
  position: relative;
  display: inline-block;
  font-weight: 400;
  font-style: normal;
  speak: none;
  text-transform: none;
}

/*
*
* Tables custom
*/

/*
* Dividers
*/

/*
* Buttons
*/

@-moz-document url-prefix() {
}

/*
* Form styles
*/

/*
* Posts
*/

/*
*
* Quotes
*/

/*
* Thumbnails
*/

.thumbnail-minimal {
  position: relative;
  display: block;
  overflow: hidden;
  background: #959af1;
}

.thumbnail-minimal:before {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  transform: scale(2) rotate(45deg) translate3d(0, -100%, 0);
  transition: transform .6s;
  pointer-events: none;
  z-index: 1;
}

.thumbnail-minimal img {
  width: 100%;
  will-change: transform;
  transform: scale(1.05);
  transition: all .3s;
}

.thumbnail-minimal:hover:before {
  transform: scale(2) rotate(45deg) translate3d(0, 100%, 0);
}

.thumbnail-minimal:hover img {
  transform: none;
  opacity: .8;
}

/*
* Breadcrumbs
*/

/*
*
* Pagination custom
*/

/*
* Snackbars
*/

/*
* Footers
*/

.contacts-creative {
  letter-spacing: .05em;
  color: #151515;
}

.contacts-creative a, .contacts-creative a:focus, .contacts-creative a:active {
  color: inherit;
}

.contacts-creative a:hover {
  color: #959af1;
}

.contacts-creative .icon {
  vertical-align: middle;
  font-size: 18px;
  line-height: 21px;
  color: #959af1;
}

.contacts-creative li + li {
  margin-top: 12px;
}

@media (min-width: 768px) {
  .contacts-creative .icon {
    line-height: 24px;
  }

  .contacts-creative li + li {
    margin-top: 18px;
  }
}

.footer-modern {
  text-align: center;
  background: #ffffff;
}

.footer-modern-title {
  letter-spacing: .2em;
  text-transform: uppercase;
}

.footer-modern-list {
  text-align: left;
  columns: 2;
  break-inside: avoid;
  -moz-column-gap: 20px;
  -webkit-column-gap: 20px;
  margin-bottom: -7px;
  color: #151515;
}

.footer-modern-list > li {
  text-indent: -20px;
  padding-left: 20px;
  transition: all .25s ease;
}

.footer-modern-list > li::before {
  display: inline-block;
  vertical-align: middle;
  content: '';
  height: 2px;
  width: 10px;
  margin-right: 10px;
  background: #cccccc;
  transition: inherit;
}

.footer-modern-list > li:hover a {
  color: #959af1;
}

.footer-modern-list > li {
  margin-bottom: 7px;
}

.footer-modern-list a {
  vertical-align: middle;
}

.footer-modern-list a, .footer-modern-list a:focus, .footer-modern-list a:active {
  color: inherit;
}

.footer-modern-list a:hover {
  color: #959af1;
}

.footer-modern-title + * {
  margin-top: 25px;
}

.footer-modern-panel {
  padding: 20px 0;
  border-top: 1px solid #e1e1e1;
}

@media (min-width: 576px) and (max-width: 575.98px) {
  .footer-modern-list-2 {
    columns: 1;
  }
}

@media (min-width: 768px) {
  .footer-modern {
    text-align: left;
  }

  .footer-modern-list > li {
    text-indent: -34px;
    padding-left: 34px;
  }

  .footer-modern-list > li::before {
    width: 17px;
    margin-right: 17px;
  }

  .footer-modern-title + .row {
    margin-top: 35px;
  }
}

@media (min-width: 992px) {
  .footer-modern-list {
    -moz-column-gap: 30px;
    -webkit-column-gap: 30px;
  }

  .footer-modern-panel {
    padding: 30px 0;
  }
}

@media (min-width: 1200px) {
  .footer-modern-list {
    max-width: 94%;
  }

  .footer-modern-list > li {
    padding-right: 17px;
  }

  .footer-modern-list > li:hover {
    padding-right: 0;
  }

  .footer-modern-list > li:hover::before {
    width: 34px;
    background: #959af1;
  }

  .footer-modern-panel {
    padding: 35px 0;
  }
}


@supports (object-fit: cover) {
}

/*
* Page layout
*/

/* html.boxed body {
	background: #e1e1e1 url(../images/bg-pattern-boxed.png) repeat fixed;
} */

/*
* Text styling
*/

/*
* Offsets
*/

* + .row {
  margin-top: 30px;
}

@media (min-width: 768px) {
  * + .row {
    margin-top: 40px;
  }
}

.row-10 {
  margin-bottom: -10px;
}

.row-10 > * {
  margin-bottom: 10px;
}

.row-40 {
  margin-bottom: -40px;
}

.row-40 > * {
  margin-bottom: 40px;
}

@media (min-width: 768px) {
  .row-md-50 {
    margin-bottom: -50px;
  }

  .row-md-50 > * {
    margin-bottom: 50px;
  }
}

/*
*
* Sections
*/

.section-xl {
  padding: 70px 0;
}

@media (min-width: 768px) {
  .section-xl {
    padding: 80px 0;
  }
}

@media (min-width: 992px) {
  .section-xl {
    padding: 90px 0;
  }
}

@media (min-width: 1200px) {
  .section-xl {
    padding: 110px 0;
  }
}

@supports (display: grid) {
}


.bg-ovrlay * > {
  position: relative;
}

/*
* Utilities custom
*/

p.rights {
  letter-spacing: 0;
  color: #777777;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

p.rights a, p.rights a:focus, p.rights a:active {
  color: inherit;
}

p.rights a:hover {
  color: #959af1;
}

@media (min-width: 1200px) {
  .inset-xl-right-70 {
    padding-right: 70px;
  }
}

.gutters-10 {
  margin-left: -5px;
  margin-right: -5px;
}

.gutters-10 [class*='col-'] {
  padding-left: 5px;
  padding-right: 5px;
}

/*
*
* Animate.css
*/

@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(40px, 0, 0);
    transform: translate3d(40px, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(40px, 0, 0);
    transform: translate3d(40px, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue